/**
 * Product section (sections/product.liquid): gallery, variants, bundle customize, cart, related slider.
 */
(function () {
  function formatMoney(cents) {
    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.formatMoney === "function"
    ) {
      var fmt =
        window.money_without_trailing_zeros_format || window.money_format;
      return Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  function normOpt(x) {
    if (x == null || x === "" || x === false) return null;
    return String(x).trim();
  }

  var CUSTOM_SIZE_PROPERTY_FALLBACK = "Custom size";
  var CUSTOM_SIZE_DEFAULT_TOKEN = "custom";

  function isCustomSizeWrapExpanded(wrap) {
    return !!(wrap && wrap.classList.contains("is-visible"));
  }

  function customSizeTriggerToken(wrap) {
    var t = wrap && wrap.getAttribute("data-custom-size-trigger-token");
    if (t && t.length) return String(t).toLowerCase();
    return CUSTOM_SIZE_DEFAULT_TOKEN;
  }

  function variantTriggersCustomSize(variant, token) {
    if (!variant) return false;
    var t = (token || CUSTOM_SIZE_DEFAULT_TOKEN).toLowerCase();
    if (!t) return false;
    var keys = ["option1", "option2", "option3"];
    for (var i = 0; i < keys.length; i++) {
      var v = variant[keys[i]];
      if (v != null && String(v).toLowerCase().indexOf(t) !== -1) return true;
    }
    return false;
  }

  function syncCustomSizeWrapVisibility(wrap, variant) {
    if (!wrap) return;
    var show = variantTriggersCustomSize(variant, customSizeTriggerToken(wrap));
    var wasExpanded = wrap.classList.contains("is-visible");
    wrap.removeAttribute("hidden");
    if (show) {
      wrap.classList.add("is-visible");
      wrap.setAttribute("aria-hidden", "false");
      if (!wasExpanded) {
        var inpOpen = wrap.querySelector("[data-custom-size-input]");
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!inpOpen || typeof inpOpen.focus !== "function") return;
            try {
              inpOpen.focus({ preventScroll: true });
            } catch (e) {
              inpOpen.focus();
            }
          });
        });
      }
    } else {
      wrap.classList.remove("is-visible");
      wrap.setAttribute("aria-hidden", "true");
      var inpClose = wrap.querySelector("[data-custom-size-input]");
      if (inpClose) {
        if (document.activeElement === inpClose) inpClose.blur();
        inpClose.value = "";
      }
    }
  }

  function isCustomSizeVariantActive(wrap, variant) {
    if (!wrap || !variant) return false;
    return variantTriggersCustomSize(variant, customSizeTriggerToken(wrap));
  }

  function syncCustomSizePriceVaryMsg(root, variant) {
    var el = root.querySelector("[data-main-price-vary-msg]");
    if (!el) return;
    var wrap = root.querySelector("[data-custom-size-field]");
    var on = !!(variant && wrap && isCustomSizeVariantActive(wrap, variant));
    if (on) el.removeAttribute("hidden");
    else el.setAttribute("hidden", "");
  }

  function syncCustomSizePriceVaryMsgBundle(root, products, selected) {
    var el = root.querySelector("[data-main-price-vary-msg]");
    if (!el) return;
    var any = false;
    var n = (products && products.length) || 0;
    for (var i = 0; i < n; i++) {
      var panel = root.querySelector(
        '[data-bundle-variant-panel][data-bundle-index="' + i + '"]'
      );
      var wrap = panel && panel.querySelector("[data-custom-size-field]");
      var v = selected[i];
      if (wrap && v && isCustomSizeVariantActive(wrap, v)) {
        any = true;
        break;
      }
    }
    if (any) el.removeAttribute("hidden");
    else el.setAttribute("hidden", "");
  }

  function isCustomSizeEntryPending(root, bundleIndex, variant) {
    var wrap = null;
    if (typeof bundleIndex === "number" && bundleIndex >= 0) {
      var panel = root.querySelector(
        '[data-bundle-variant-panel][data-bundle-index="' + bundleIndex + '"]'
      );
      wrap = panel && panel.querySelector("[data-custom-size-field]");
    } else {
      wrap = root.querySelector("[data-custom-size-field]");
    }
    if (!wrap || !isCustomSizeWrapExpanded(wrap) || !variant || !variant.available) return false;
    if (!variantTriggersCustomSize(variant, customSizeTriggerToken(wrap))) return false;
    var inp = wrap.querySelector("[data-custom-size-input]");
    return !inp || !String(inp.value || "").trim();
  }

  function validateCustomSizeForVariant(root, bundleIndex, variant) {
    if (!isCustomSizeEntryPending(root, bundleIndex, variant)) return null;
    return "Please enter your custom size.";
  }

  function anyBundleCustomSizePending(root, products, selected) {
    for (var i = 0; i < products.length; i++) {
      if (isCustomSizeEntryPending(root, i, selected[i])) return true;
    }
    return false;
  }

  function applyCustomSizePrimaryActions(root, variant) {
    var addBtn = root.querySelector("[data-main-add-to-cart]");
    var buyBtn = root.querySelector("[data-main-buy-now]");
    if (!addBtn) return;
    if (!variant || !variant.available) return;

    var wrap = root.querySelector("[data-custom-size-field]");
    if (!wrap || !isCustomSizeWrapExpanded(wrap)) return;

    if (!variantTriggersCustomSize(variant, customSizeTriggerToken(wrap))) return;

    var pending =
      addBtn.getAttribute("data-label-pending-custom-size") || "Enter Custom Size";
    var inp = wrap.querySelector("[data-custom-size-input]");
    var empty = !inp || !String(inp.value || "").trim();
    if (empty) {
      addBtn.disabled = true;
      addBtn.textContent = pending;
      if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.textContent =
          buyBtn.getAttribute("data-label-pending-custom-size") || pending;
      }
    } else {
      addBtn.disabled = false;
      addBtn.textContent = addBtn.getAttribute("data-label-add") || "Add to cart";
      if (buyBtn) {
        buyBtn.disabled = false;
        buyBtn.textContent = buyBtn.getAttribute("data-label-buy") || "Buy now";
      }
    }
  }

  function buildCustomSizeProperties(root, bundleIndex, variant) {
    var wrap = null;
    if (typeof bundleIndex === "number" && bundleIndex >= 0) {
      var panel = root.querySelector(
        '[data-bundle-variant-panel][data-bundle-index="' + bundleIndex + '"]'
      );
      wrap = panel && panel.querySelector("[data-custom-size-field]");
    } else {
      wrap = root.querySelector("[data-custom-size-field]");
    }
    if (!wrap || !isCustomSizeWrapExpanded(wrap)) return null;
    if (!variantTriggersCustomSize(variant, customSizeTriggerToken(wrap))) return null;
    var inp = wrap.querySelector("[data-custom-size-input]");
    var val = inp && inp.value ? String(inp.value).trim() : "";
    if (!val) return null;
    var propName =
      wrap.getAttribute("data-property-name") || CUSTOM_SIZE_PROPERTY_FALLBACK;
    var out = {};
    out[propName] = val;
    return out;
  }

  function syncBuyNowButton(buyBtn, opts) {
    if (!buyBtn) return;
    opts = opts || {};
    var unavailable = !!opts.unavailable;
    var sold = !!opts.sold;
    var off = unavailable || sold;
    buyBtn.disabled = off;
    var labelBuy = buyBtn.getAttribute("data-label-buy") || "Buy now";
    var labelSold = buyBtn.getAttribute("data-label-sold-out") || "Sold out";
    var labelUnavail =
      buyBtn.getAttribute("data-label-unavailable") || "Unavailable";
    if (unavailable) buyBtn.textContent = labelUnavail;
    else if (sold) buyBtn.textContent = labelSold;
    else buyBtn.textContent = labelBuy;
  }

  function findVariant(variants, option1, option2, option3) {
    var o1 = normOpt(option1);
    var o2 = normOpt(option2);
    var o3 = normOpt(option3);
    return variants.find(function (v) {
      return (
        normOpt(v.option1) === o1 &&
        normOpt(v.option2) === o2 &&
        normOpt(v.option3) === o3
      );
    });
  }

  function variantImageUrl(v) {
    if (!v) return null;
    if (typeof v.featured_image === "string") return v.featured_image;
    if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    if (
      v.featured_media &&
      v.featured_media.preview_image &&
      v.featured_media.preview_image.src
    ) {
      return v.featured_media.preview_image.src;
    }
    return null;
  }

  function relatedSlideImageUrl(variant, product) {
    var u = variantImageUrl(variant);
    if (u) return u;
    if (!product) return null;
    var fi = product.featured_image;
    if (typeof fi === "string" && fi) return fi;
    if (fi && fi.src) return fi;
    var imgs = product.images;
    if (imgs && imgs.length) {
      var im0 = imgs[0];
      if (typeof im0 === "string") return im0;
      if (im0 && im0.src) return im0;
    }
    return null;
  }

  function readJson(id, scope) {
    var el = null;
    if (scope && scope.querySelector && typeof CSS !== "undefined" && CSS.escape) {
      el = scope.querySelector("#" + CSS.escape(id));
    }
    if (!el) el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var PRODUCT_UPDATE_MIN_MS = 260;
  var productUpdateHideByShell = new WeakMap();

  function setProductUpdateLoading(shell, on) {
    if (!shell) return;
    shell.querySelectorAll("[data-product-update-overlay]").forEach(function (el) {
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-hidden", on ? "false" : "true");
    });
  }

  function runWithProductUpdateLoading(shell, workFn) {
    if (typeof workFn !== "function") return;
    if (!shell) {
      workFn();
      return;
    }
    var prev = productUpdateHideByShell.get(shell);
    if (prev) {
      clearTimeout(prev);
      productUpdateHideByShell.delete(shell);
    }
    setProductUpdateLoading(shell, true);
    var t0 = Date.now();
    try {
      workFn();
    } finally {
      var wait = Math.max(0, PRODUCT_UPDATE_MIN_MS - (Date.now() - t0));
      var id = setTimeout(function () {
        productUpdateHideByShell.delete(shell);
        setProductUpdateLoading(shell, false);
      }, wait);
      productUpdateHideByShell.set(shell, id);
    }
  }

  function parseBundleQty(raw, n) {
    raw = String(raw || "").trim().replace(/\s/g, "");
    var out = [];
    var parts = raw.length
      ? raw.split(/[,\-]+/).filter(function (p) {
          return p.length;
        })
      : [];
    for (var i = 0; i < n; i++) {
      var q = parseInt(parts[i], 10);
      out.push(isNaN(q) || q < 1 ? 1 : q);
    }
    return out;
  }

  function setupThumbScroll(wrap) {
    if (!wrap) return;
    var viewport = wrap.querySelector(".product-main__thumb-viewport");
    var row = wrap.querySelector(".product-main__thumb-row");
    var prevBtn = wrap.querySelector("[data-product-thumb-prev]");
    var nextBtn = wrap.querySelector("[data-product-thumb-next]");
    if (!viewport || !row) return;

    function getStep() {
      var first = row.querySelector(".product-main__thumb");
      if (!first) return 0;
      var cs = getComputedStyle(row);
      var gap =
        parseFloat(cs.gap) ||
        parseFloat(cs.columnGap) ||
        parseFloat(cs.rowGap) ||
        0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = row.scrollWidth - viewport.clientWidth;
      var threshold = 1;
      if (maxScroll <= threshold) {
        if (prevBtn) {
          prevBtn.style.opacity = "0";
          prevBtn.style.pointerEvents = "none";
        }
        if (nextBtn) {
          nextBtn.style.opacity = "0";
          nextBtn.style.pointerEvents = "none";
        }
      } else {
        var left = viewport.scrollLeft;
        if (prevBtn) {
          var showPrev = left > threshold;
          prevBtn.style.opacity = showPrev ? "1" : "0";
          prevBtn.style.pointerEvents = showPrev ? "auto" : "none";
        }
        if (nextBtn) {
          var showNext = left < maxScroll - threshold;
          nextBtn.style.opacity = showNext ? "1" : "0";
          nextBtn.style.pointerEvents = showNext ? "auto" : "none";
        }
      }
    }

    function scrollByStep(dir) {
      var step = getStep();
      if (step <= 0) return;
      viewport.scrollBy({ left: dir * step, behavior: "smooth" });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        scrollByStep(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        scrollByStep(1);
      });
    }
    viewport.addEventListener("scroll", function () {
      requestAnimationFrame(updateArrows);
    });
    window.addEventListener(
      "resize",
      function () {
        updateArrows();
      },
      { passive: true }
    );
    updateArrows();
  }

  /**
   * Color swatch row on PDP uses .card-product__colors-wrap + data-product-thumb-scroll but lives
   * outside .card-product, so card-product.js never runs. Match card-product.js setupSwatchRow and
   * add .is-ready so card-product.css reveals the row (opacity).
   */
  function setupProductMainColorSwatchScroll(wrap) {
    if (!wrap) return;
    var viewport = wrap.querySelector(".card-product__colors-viewport");
    var row = wrap.querySelector(".card-product__colors--row");
    var prevBtn = wrap.querySelector("[data-product-thumb-prev]");
    var nextBtn = wrap.querySelector("[data-product-thumb-next]");
    if (!viewport || !row) return;

    function getStep() {
      var first = row.querySelector(".card-product__color-option");
      if (!first) return 0;
      var cs = getComputedStyle(row);
      var gap =
        parseFloat(cs.gap) ||
        parseFloat(cs.columnGap) ||
        parseFloat(cs.rowGap) ||
        0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var maxScroll = row.scrollWidth - viewport.clientWidth;
      var threshold = 1;
      if (maxScroll <= threshold) {
        if (prevBtn) {
          prevBtn.style.opacity = "0";
          prevBtn.style.pointerEvents = "none";
        }
        if (nextBtn) {
          nextBtn.style.opacity = "0";
          nextBtn.style.pointerEvents = "none";
        }
      } else {
        var left = viewport.scrollLeft;
        if (prevBtn) {
          var showPrev = left > threshold;
          prevBtn.style.opacity = showPrev ? "1" : "0";
          prevBtn.style.pointerEvents = showPrev ? "auto" : "none";
        }
        if (nextBtn) {
          var showNext = left < maxScroll - threshold;
          nextBtn.style.opacity = showNext ? "1" : "0";
          nextBtn.style.pointerEvents = showNext ? "auto" : "none";
        }
      }
    }

    function scrollByStep(dir) {
      var step = getStep();
      if (step <= 0) return;
      viewport.scrollBy({ left: dir * step, behavior: "smooth" });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollByStep(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollByStep(1);
      });
    }

    viewport.addEventListener("scroll", updateArrows, { passive: true });

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        updateArrows();
      });
      ro.observe(viewport);
      ro.observe(row);
    } else {
      window.addEventListener("resize", updateArrows, false);
    }

    wrap.classList.add("is-ready");
    row.removeAttribute("aria-hidden");
    updateArrows();
  }

  function layoutGalleryTrack(track, slides) {
    var n = slides.length;
    if (n <= 0) return;
    var pct = 100 / n;
    track.style.width = n * 100 + "%";
    slides.forEach(function (slide) {
      slide.style.flex = "0 0 " + pct + "%";
      slide.style.maxWidth = pct + "%";
    });
  }

  /**
   * Native HTML5 videos only: active slide plays (unmuted when allowed); others pause + muted.
   * External embed iframes are not controlled here.
   */
  function syncGalleryVideos(slides, activeIndex) {
    if (!slides || !slides.length) return;
    slides.forEach(function (slide, i) {
      var v = slide.querySelector("video");
      if (!v) return;
      if (i === activeIndex) {
        v.muted = false;
        var p = v.play();
        if (p && typeof p.then === "function") {
          p.catch(function () {
            v.muted = true;
            var p2 = v.play();
            if (p2 && typeof p2.catch === "function") {
              p2.catch(function () {});
            }
          });
        }
      } else {
        v.pause();
        v.muted = true;
      }
    });
  }

  function applyProductGalleryState(shell, slideIndex) {
    var track = shell.querySelector("[data-product-gallery-track]");
    if (!track) return;
    var slides = track.querySelectorAll("[data-gallery-slide]");
    var n = slides.length;
    if (n <= 0) return;
    var i = ((slideIndex % n) + n) % n;
    shell._pmGalleryIndex = i;
    var pctMove = (100 / n) * i;
    track.style.transform = "translateX(-" + pctMove + "%)";
    var thumbs = shell.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (t, ti) {
      t.classList.toggle("is-active", ti === i);
    });
    syncGalleryVideos(slides, i);
  }

  function initGallery(shell) {
    var track = shell.querySelector("[data-product-gallery-track]");
    var viewport = shell.querySelector("[data-product-gallery-viewport]");
    if (!track || !viewport) return;

    var slides = track.querySelectorAll("[data-gallery-slide]");
    var thumbs = shell.querySelectorAll("[data-gallery-thumb]");
    var prev = shell.querySelector("[data-gallery-prev]");
    var next = shell.querySelector("[data-gallery-next]");
    var n = slides.length;
    if (n === 0) return;

    layoutGalleryTrack(track, slides);

    function setActive(i) {
      applyProductGalleryState(shell, i);
    }

    if (prev) {
      prev.addEventListener("click", function () {
        setActive((shell._pmGalleryIndex || 0) - 1);
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        setActive((shell._pmGalleryIndex || 0) + 1);
      });
    }
    thumbs.forEach(function (t, ti) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        setActive(ti);
      });
    });
    setActive(0);

    var thumbWrap = shell.querySelector(".product-main__gallery [data-product-thumb-scroll]");
    setupThumbScroll(thumbWrap);

    window.addEventListener(
      "resize",
      function () {
        layoutGalleryTrack(track, slides);
        applyProductGalleryState(shell, shell._pmGalleryIndex || 0);
      },
      { passive: true }
    );
  }

  function getOptionValues(root, prefix) {
    prefix = prefix || "";
    function val(optionBase) {
      var name = optionBase + prefix;
      var radio = root.querySelector('input[type="radio"][name="' + name + '"]:checked');
      if (radio) return radio.value || null;
      var sel = root.querySelector('select[name="' + name + '"]');
      if (sel) return sel.value || null;
      return null;
    }
    return [val("option1"), val("option2"), val("option3")];
  }

  function bindOptionChange(root, prefix, cb) {
    prefix = prefix || "";
    ["option1", "option2", "option3"].forEach(function (base) {
      var nm = base + prefix;
      root.querySelectorAll("[name='" + nm + "']").forEach(function (el) {
        el.addEventListener("change", cb);
      });
    });
  }

  function updateVariantUi(root, product, variant, priceRoot, shell) {
    if (!priceRoot) priceRoot = root;
    shell = shell || (root.closest && root.closest(".product-main")) || root;
    var cur = priceRoot.querySelector("[data-main-price-current]");
    var cmp = priceRoot.querySelector("[data-main-price-compare]");
    var disc = priceRoot.querySelector("[data-main-price-discount]");
    var hid = root.querySelector("[data-main-variant-id]");
    var addBtn = root.querySelector("[data-main-add-to-cart]");
    var buyBtn = root.querySelector("[data-main-buy-now]");
    var err = root.querySelector("[data-main-cart-error]");

    if (err) err.textContent = "";

    if (!variant) {
      if (hid) hid.value = "";
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute("data-label-unavailable") || "Unavailable";
      }
      syncBuyNowButton(buyBtn, { unavailable: true });
      return;
    }

    if (hid) hid.value = String(variant.id);
    var sold = !variant.available;
    if (addBtn) {
      addBtn.disabled = sold;
      addBtn.textContent = sold
        ? addBtn.getAttribute("data-label-sold-out") || "Sold out"
        : addBtn.getAttribute("data-label-add") || "Add to cart";
    }
    syncBuyNowButton(buyBtn, { sold: sold });

    if (cur) cur.textContent = formatMoney(variant.price);
    if (cmp && disc) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        cmp.textContent = formatMoney(variant.compare_at_price);
        cmp.style.display = "";
        var pct = Math.round(
          ((variant.compare_at_price - variant.price) *
            100) /
            variant.compare_at_price
        );
        disc.textContent = pct + "% OFF";
        disc.style.display = "";
      } else {
        cmp.style.display = "none";
        disc.style.display = "none";
      }
    }

    var mediaId =
      variant.featured_media_id ||
      (variant.featured_media && variant.featured_media.id) ||
      null;
    var slideEl =
      mediaId && shell
        ? shell.querySelector("[data-slide-for-media='" + mediaId + "']")
        : null;
    var slideIndex = slideEl
      ? parseInt(slideEl.getAttribute("data-gallery-slide-index"), 10)
      : NaN;
    if (!isNaN(slideIndex) && shell) {
      applyProductGalleryState(shell, slideIndex);
    }

    applyCustomSizePrimaryActions(root, variant);
    syncCustomSizePriceVaryMsg(root, variant);
  }

  function updateOptionAvailability(root, prefix, product) {
    prefix = prefix || "";
    var variants = product.variants || [];
    for (var pos = 1; pos <= 3; pos++) {
      var name = "option" + pos + prefix;
      var inputs = root.querySelectorAll('input[type="radio"][name="' + name + '"]');
      inputs.forEach(function (inp) {
        var tryVal = inp.value;
        var cur = getOptionValues(root, prefix);
        cur[pos - 1] = tryVal;
        var v = findVariant(variants, cur[0], cur[1], cur[2]);
        var avail = !!(v && v.available);
        var lbl = inp.closest(".product-main__opt-cell");
        if (lbl) {
          lbl.classList.toggle("is-unavailable", !avail);
          inp.removeAttribute("disabled");
        }
      });

      root.querySelectorAll("[data-option-swatch]").forEach(function (btn) {
        if (btn.getAttribute("data-option-name") !== name) return;
        var tryVal = btn.getAttribute("data-option-value");
        if (tryVal == null) return;
        var cur = getOptionValues(root, prefix);
        cur[pos - 1] = tryVal;
        var v = findVariant(variants, cur[0], cur[1], cur[2]);
        var avail = !!(v && v.available);
        btn.classList.toggle("is-unavailable", !avail);
        btn.classList.remove("disabled");
      });
    }
  }

  function setSelectedUi(el, on) {
    if (!el) return;
    el.classList.toggle("is-selected", on);
    el.classList.toggle("selected", on);
  }

  function syncOptionSelectionState(root, prefix) {
    prefix = prefix || "";
    ["option1", "option2", "option3"].forEach(function (base) {
      var name = base + prefix;
      var radios = root.querySelectorAll('input[type="radio"][name="' + name + '"]');
      if (!radios.length) return;
      radios.forEach(function (inp) {
        var lbl = inp.closest(".product-main__opt-cell");
        if (lbl) setSelectedUi(lbl, inp.checked);
      });
      var checked = root.querySelector('input[type="radio"][name="' + name + '"]:checked');
      var cv = checked ? checked.value : null;
      root.querySelectorAll("[data-option-swatch]").forEach(function (btn) {
        if (btn.getAttribute("data-option-name") !== name) return;
        var match = normOpt(btn.getAttribute("data-option-value")) === normOpt(cv);
        setSelectedUi(btn, match);
        btn.setAttribute("aria-current", match ? "true" : "false");
      });
      var curLbl = root.querySelector(
        '[data-option-current-for="' + name + '"]'
      );
      if (curLbl) {
        curLbl.textContent = cv != null && cv !== "" ? String(cv) : "";
      }
    });
  }

  function initSingleProduct(root, data) {
    var product = data.product;
    if (!product || !product.variants) return;
    delete root._pmRefreshBundlePrice;
    var shell = root.closest(".product-main");

    var singleProductInitialRefresh = true;

    function refresh() {
      function apply() {
        var opts = getOptionValues(root, "");
        var v = findVariant(product.variants, opts[0], opts[1], opts[2]);
        updateOptionAvailability(root, "", product);
        syncOptionSelectionState(root, "");
        syncCustomSizeWrapVisibility(root.querySelector("[data-custom-size-field]"), v);
        updateVariantUi(root, product, v, root, shell);
      }
      if (singleProductInitialRefresh) {
        singleProductInitialRefresh = false;
        apply();
        return;
      }
      runWithProductUpdateLoading(shell, apply);
    }

    root.__productRefresh = function () {
      runWithProductUpdateLoading(shell, function () {
        var opts = getOptionValues(root, "");
        var v = findVariant(product.variants, opts[0], opts[1], opts[2]);
        updateOptionAvailability(root, "", product);
        syncOptionSelectionState(root, "");
        syncCustomSizeWrapVisibility(root.querySelector("[data-custom-size-field]"), v);
        updateVariantUi(root, product, v, root, shell);
      });
    };

    bindOptionChange(root, "", refresh);
    root.querySelectorAll("[data-option-swatch]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var name = btn.getAttribute("data-option-name");
        var val = btn.getAttribute("data-option-value");
        if (!name) return;
        root.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function (r) {
          r.checked = normOpt(r.value) === normOpt(val);
        });
        refresh();
      });
    });
    refresh();
  }

  function initBundleMode(root, data) {
    var products = data.bundleProducts || [];
    if (!products.length) return;
    var bundleDiscount = Math.max(0, parseInt(data.bundleDiscount, 10) || 0);

    var shell = root.closest(".product-main");
    var bundleBootstrapping = true;
    var skipBundleLoaderOnce = false;

    var selected = products.map(function (p) {
      var v = (p.variants || []).find(function (x) {
        return x.available;
      });
      return v || (p.variants && p.variants[0]) || null;
    });

    function prefixFor(i) {
      return "__b" + i;
    }

    function panelPrices() {
      var sum = 0;
      selected.forEach(function (v) {
        if (!v) return;
        sum += v.price;
      });
      var discounted = Math.max(0, sum - bundleDiscount);
      return { sum: sum, discounted: discounted };
    }

    function refreshBundlePrice() {
      function apply() {
        var cur = root.querySelector("[data-main-price-current]");
        var cmp = root.querySelector("[data-main-price-compare]");
        var disc = root.querySelector("[data-main-price-discount]");
        var p = panelPrices();
        if (cur) cur.textContent = formatMoney(p.discounted);
        if (cmp && disc) {
          if (p.sum > p.discounted) {
            cmp.textContent = formatMoney(p.sum);
            cmp.style.display = "";
            var pct = p.sum > 0 ? Math.round(((p.sum - p.discounted) * 100) / p.sum) : 0;
            disc.textContent = pct + "% OFF";
            disc.style.display = "";
          } else {
            cmp.style.display = "none";
            disc.style.display = "none";
          }
        }

        var sold = selected.some(function (v) {
          return !v || !v.available;
        });
        var addBtn = root.querySelector("[data-main-add-to-cart]");
        var buyBtn = root.querySelector("[data-main-buy-now]");
        var pendingCs =
          !sold && anyBundleCustomSizePending(root, products, selected);
        var pendLabel =
          (addBtn && addBtn.getAttribute("data-label-pending-custom-size")) ||
          "Enter Custom Size";
        if (addBtn) {
          if (sold) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute("data-label-sold-out") || "Sold out";
          } else if (pendingCs) {
            addBtn.disabled = true;
            addBtn.textContent = pendLabel;
          } else {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute("data-label-add") || "Add to cart";
          }
        }
        if (sold) {
          syncBuyNowButton(buyBtn, { sold: true });
        } else if (pendingCs) {
          if (buyBtn) {
            buyBtn.disabled = true;
            buyBtn.textContent =
              buyBtn.getAttribute("data-label-pending-custom-size") || pendLabel;
          }
        } else {
          syncBuyNowButton(buyBtn, { sold: false });
        }

        products.forEach(function (prod, i) {
          var v = selected[i];
          var line = root.querySelector('[data-bundle-line-index="' + i + '"]');
          if (!line || !v) return;
          var img = line.querySelector("[data-bundle-line-image]");
          var u = variantImageUrl(v);
          if (img && u) img.src = u;
          var optsEl = line.querySelector("[data-bundle-line-opts]");
          if (optsEl && v && prod.options) {
            optsEl.innerHTML = "";
            for (var oi = 0; oi < prod.options.length; oi++) {
              var key = "option" + (oi + 1);
              if (!v[key]) continue;
              var row = document.createElement("div");
              row.className = "product-main__bundle-line-opt";
              row.textContent = prod.options[oi] + ": " + v[key];
              optsEl.appendChild(row);
            }
          }
          var pc = line.querySelector("[data-bundle-line-price]");
          var pcmp = line.querySelector("[data-bundle-line-compare]");
          if (pc) pc.textContent = formatMoney(v.price);
          if (pcmp) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              pcmp.textContent = formatMoney(v.compare_at_price);
              pcmp.style.display = "";
            } else {
              pcmp.style.display = "none";
            }
          }
        });

        root.querySelectorAll("[data-related-slide]").forEach(function (slide) {
          var handle = slide.getAttribute("data-product-handle");
          var prod = products.find(function (p) {
            return p.handle === handle;
          });
          if (!prod) return;
          var vi = products.indexOf(prod);
          var v = selected[vi];
          if (!v) return;
          var rimg = slide.querySelector("[data-related-image]");
          var ru = relatedSlideImageUrl(v, prod);
          if (rimg && ru) {
            rimg.src = ru;
            rimg.alt =
              (prod.title || "") +
              " — " +
              [v.option1, v.option2, v.option3].filter(Boolean).join(" / ");
          }
          var rpc = slide.querySelector("[data-related-price]");
          var rpcmp = slide.querySelector("[data-related-compare]");
          if (rpc) rpc.textContent = formatMoney(v.price);
          if (rpcmp) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              rpcmp.textContent = formatMoney(v.compare_at_price);
              rpcmp.style.display = "";
            } else {
              rpcmp.style.display = "none";
            }
          }
          var radd = slide.querySelector("[data-related-add]");
          if (radd) {
            radd.dataset.variantId = String(v.id);
            radd.disabled = !v.available;
            var la = radd.getAttribute("data-label-add") || "Add";
            var ls = radd.getAttribute("data-label-sold-out") || "Sold out";
            radd.textContent = v.available ? la : ls;
          }
        });

        syncCustomSizePriceVaryMsgBundle(root, products, selected);
      }

      if (bundleBootstrapping || skipBundleLoaderOnce || !shell) apply();
      else runWithProductUpdateLoading(shell, apply);
    }

    function bindPanel(i) {
      var px = prefixFor(i);
      function refreshPanel() {
        var opts = getOptionValues(root, px);
        var prod = products[i];
        var v = findVariant(prod.variants || [], opts[0], opts[1], opts[2]);
        selected[i] = v;
        updateOptionAvailability(root, px, prod);
        syncOptionSelectionState(root, px);
        var panel = root.querySelector(
          '[data-bundle-variant-panel][data-bundle-index="' + i + '"]'
        );
        var csWrap = panel && panel.querySelector("[data-custom-size-field]");
        syncCustomSizeWrapVisibility(csWrap, v);
        refreshBundlePrice();
      }
      bindOptionChange(root, px, refreshPanel);
      root.querySelectorAll('[data-option-swatch][data-bundle-index="' + i + '"]').forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          var name = btn.getAttribute("data-option-name");
          var val = btn.getAttribute("data-option-value");
          root.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function (r) {
            r.checked = normOpt(r.value) === normOpt(val);
          });
          refreshPanel();
        });
      });
      refreshPanel();
    }

    for (var i = 0; i < products.length; i++) {
      bindPanel(i);
    }
    bundleBootstrapping = false;

    root.__productRefresh = function () {
      for (var j = 0; j < products.length; j++) {
        var pj = prefixFor(j);
        updateOptionAvailability(root, pj, products[j]);
        syncOptionSelectionState(root, pj);
        var panel = root.querySelector(
          '[data-bundle-variant-panel][data-bundle-index="' + j + '"]'
        );
        var csWrap = panel && panel.querySelector("[data-custom-size-field]");
        syncCustomSizeWrapVisibility(csWrap, selected[j]);
      }
      refreshBundlePrice();
    };

    var activePanel = 0;
    var panels = root.querySelectorAll("[data-bundle-variant-panel]");

    function showPanel(idx) {
      activePanel = idx;
      panels.forEach(function (p) {
        var pi = parseInt(p.getAttribute("data-bundle-index"), 10);
        var hidden = pi !== idx;
        p.hidden = hidden;
        p.setAttribute("aria-hidden", hidden ? "true" : "false");
        if (window.gsap) {
          if (!hidden) {
            window.gsap.fromTo(
              p,
              { opacity: 0, y: 8 },
              { opacity: 1, y: 0, duration: 0.25, clearProps: "opacity,transform" }
            );
          }
        }
      });
      root.querySelectorAll("[data-bundle-customize]").forEach(function (btn) {
        var bi = parseInt(btn.getAttribute("data-bundle-index"), 10);
        var on = bi === idx;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
        var labelEl = btn.querySelector("[data-bundle-customize-label]");
        var nextText = on
          ? btn.getAttribute("data-label-active") || "Editing"
          : btn.getAttribute("data-label-default") || "Customize";
        if (labelEl) labelEl.textContent = nextText;
        else btn.textContent = nextText;
      });
    }

    root.querySelectorAll("[data-bundle-customize]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.getAttribute("data-bundle-index"), 10);
        showPanel(idx);
        var anchor = root.querySelector("#product-variants-anchor-" + root.getAttribute("data-section-id"));
        if (window.lenis && anchor) {
          window.lenis.scrollTo(anchor, { offset: -100, duration: 0.9 });
        } else if (anchor) {
          anchor.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    showPanel(0);
    skipBundleLoaderOnce = true;
    refreshBundlePrice();
    skipBundleLoaderOnce = false;

    root._pmRefreshBundlePrice = refreshBundlePrice;
  }

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || "/cart/add";
  }

  function cartAdd(items, root, opts) {
    opts = opts || {};
    var err = root.querySelector("[data-main-cart-error]");
    if (err) err.textContent = "";
    return fetch(getCartAddUrl() + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var msg =
            (json && (json.description || json.message || json.error)) ||
            "Could not add to cart.";
          if (err) err.textContent = msg;
          throw new Error(msg);
        }
        if (
          !opts.skipCartDrawer &&
          typeof publish !== "undefined" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, { action: "add" });
        }
        return json;
      });
    });
  }

  function getCheckoutUrl() {
    if (window.routes && window.routes.checkout_url) return window.routes.checkout_url;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root || root === "/") return "/checkout";
    return String(root).replace(/\/+$/, "") + "/checkout";
  }

  function initCart(root, data) {
    var addBtn = root.querySelector("[data-main-add-to-cart]");
    var buyBtn = root.querySelector("[data-main-buy-now]");
    var qtySel = root.querySelector("[data-main-qty-select]");
    var err = root.querySelector("[data-main-cart-error]");

    (function setupMainQtyStepper() {
      var stepper = root.querySelector("[data-main-qty-stepper]");
      if (!stepper || stepper.dataset.pmQtyStepperBound === "1") return;
      stepper.dataset.pmQtyStepperBound = "1";
      var max = parseInt(stepper.getAttribute("data-main-qty-max"), 10) || 99;
      var valEl = stepper.querySelector("[data-main-qty-value]");
      var minus = stepper.querySelector("[data-main-qty-minus]");
      var plus = stepper.querySelector("[data-main-qty-plus]");
      if (!valEl || !minus || !plus) return;
      function getQ() {
        var q = parseInt(String(valEl.textContent || "").trim(), 10);
        return isNaN(q) ? 1 : q;
      }
      function setQ(q) {
        q = Math.max(1, Math.min(max, q));
        valEl.textContent = String(q);
        minus.disabled = q <= 1;
        plus.disabled = q >= max;
      }
      setQ(1);
      minus.addEventListener("click", function () {
        setQ(getQ() - 1);
      });
      plus.addEventListener("click", function () {
        setQ(getQ() + 1);
      });
    })();

    function multiplier() {
      var stepper = root.querySelector("[data-main-qty-stepper]");
      if (stepper) {
        var valEl = stepper.querySelector("[data-main-qty-value]");
        var q = valEl
          ? parseInt(String(valEl.textContent || "").trim(), 10)
          : 1;
        return isNaN(q) || q < 1 ? 1 : q;
      }
      if (!qtySel) return 1;
      var q2 = parseInt(qtySel.value, 10);
      return isNaN(q2) || q2 < 1 ? 1 : q2;
    }

    function itemsForBundle() {
      var products = data.bundleProducts || [];
      var base = parseBundleQty(data.bundleQuantityRaw, products.length);
      var m = multiplier();
      var out = [];
      products.forEach(function (prod, i) {
        var px = "__b" + i;
        var opts = getOptionValues(root, px);
        var v = findVariant(prod.variants || [], opts[0], opts[1], opts[2]);
        if (!v || !v.available) return;
        var bq = base[i] || 1;
        var line = { id: Number(v.id), quantity: bq * m };
        var props = buildCustomSizeProperties(root, i, v);
        if (props) line.properties = props;
        out.push(line);
      });
      return out;
    }

    function itemsSingle() {
      var hid = root.querySelector("[data-main-variant-id]");
      var raw = hid ? String(hid.value).trim() : "";
      var id = parseInt(raw, 10);
      if (!raw || isNaN(id)) return [];
      var q = multiplier();
      var line = { id: id, quantity: q };
      if (data.product && data.product.variants) {
        var opts = getOptionValues(root, "");
        var v = findVariant(data.product.variants, opts[0], opts[1], opts[2]);
        var props = buildCustomSizeProperties(root, undefined, v);
        if (props) line.properties = props;
      }
      return [line];
    }

    function validateAllCustomSizes() {
      if (data.mode === "bundle") {
        var products = data.bundleProducts || [];
        for (var i = 0; i < products.length; i++) {
          var px = "__b" + i;
          var opts = getOptionValues(root, px);
          var v = findVariant(products[i].variants || [], opts[0], opts[1], opts[2]);
          var msg = validateCustomSizeForVariant(root, i, v);
          if (msg) return msg;
        }
      } else if (data.product && data.product.variants) {
        var opts0 = getOptionValues(root, "");
        var v0 = findVariant(data.product.variants, opts0[0], opts0[1], opts0[2]);
        return validateCustomSizeForVariant(root, undefined, v0);
      }
      return null;
    }

    root.querySelectorAll("[data-custom-size-input]").forEach(function (inp) {
      if (inp.dataset.pmCustomSizeBound === "1") return;
      inp.dataset.pmCustomSizeBound = "1";
      function onCustomSizeInput() {
        if (data.mode === "bundle") {
          if (typeof root._pmRefreshBundlePrice === "function") {
            root._pmRefreshBundlePrice();
          }
        } else if (data.product && data.product.variants) {
          var opts = getOptionValues(root, "");
          var v = findVariant(data.product.variants, opts[0], opts[1], opts[2]);
          updateVariantUi(root, data.product, v, root, root.closest(".product-main"));
        }
      }
      inp.addEventListener("input", onCustomSizeInput);
      inp.addEventListener("change", onCustomSizeInput);
    });

    if (addBtn) {
      addBtn.addEventListener("click", function () {
        if (err) err.textContent = "";
        var csErr = validateAllCustomSizes();
        if (csErr) {
          if (err) err.textContent = csErr;
          return;
        }
        var items = data.mode === "bundle" ? itemsForBundle() : itemsSingle();
        if (!items.length) {
          if (err) err.textContent = "Select options.";
          return;
        }
        addBtn.disabled = true;
        cartAdd(items, root)
          .catch(function () {})
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
            if (typeof root.__productRefresh === "function") root.__productRefresh();
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener("click", function () {
        if (err) err.textContent = "";
        var csErrBuy = validateAllCustomSizes();
        if (csErrBuy) {
          if (err) err.textContent = csErrBuy;
          return;
        }
        var items = data.mode === "bundle" ? itemsForBundle() : itemsSingle();
        if (!items.length) {
          if (err) err.textContent = "Select options.";
          return;
        }
        buyBtn.disabled = true;
        cartAdd(items, root, { skipCartDrawer: true })
          .then(function () {
            window.location.assign(getCheckoutUrl());
          })
          .catch(function () {})
          .finally(function () {
            if (buyBtn) buyBtn.disabled = false;
            if (typeof root.__productRefresh === "function") root.__productRefresh();
          });
      });
    }
  }

  var relatedColorUiDocBound = false;

  function clearRelatedColorPanelLayout(panel) {
    panel.style.position = "";
    panel.style.top = "";
    panel.style.left = "";
    panel.style.right = "";
    panel.style.bottom = "";
    panel.style.minWidth = "";
    panel.style.maxHeight = "";
  }

  /* Slider track uses transform; position:fixed is resolved against that ancestor, not the viewport, so top/left from getBoundingClientRect() misplace the panel (often off-screen). Portal to body while open. */
  function portalRelatedColorPanelToBody(panel) {
    if (panel._pmPortalPlaceholder) return;
    var parent = panel.parentNode;
    if (!parent) return;
    var ph = document.createComment("related-color-panel-anchor");
    parent.insertBefore(ph, panel);
    document.body.appendChild(panel);
    panel._pmPortalPlaceholder = ph;
  }

  function restoreRelatedColorPanelFromBody(panel) {
    var ph = panel._pmPortalPlaceholder;
    panel._pmPortalPlaceholder = null;
    if (!ph || !ph.parentNode) return;
    ph.parentNode.insertBefore(panel, ph);
    ph.remove();
  }

  function positionRelatedColorPanel(trigger, panel) {
    var r = trigger.getBoundingClientRect();
    var gap = 4;
    var pad = 8;
    panel.style.position = "fixed";
    panel.style.right = "auto";
    panel.style.bottom = "auto";
    panel.style.minWidth = Math.max(r.width, 160) + "px";
    panel.style.top = r.bottom + gap + "px";
    panel.style.left = r.left + "px";
    var pr = panel.getBoundingClientRect();
    var left = r.left;
    if (pr.right > window.innerWidth - pad) {
      left = Math.max(pad, window.innerWidth - pad - pr.width);
    }
    if (left < pad) left = pad;
    panel.style.left = left + "px";
    var spaceBelow = window.innerHeight - r.bottom - gap - pad;
    var maxH = Math.max(96, Math.min(240, spaceBelow));
    panel.style.maxHeight = maxH + "px";
    var ph = panel.getBoundingClientRect().height;
    if (ph > 0 && r.bottom + gap + ph > window.innerHeight - pad) {
      var topAbove = r.top - gap - ph;
      if (topAbove >= pad) {
        panel.style.top = topAbove + "px";
        panel.style.maxHeight =
          Math.max(96, Math.min(240, r.top - gap - pad)) + "px";
      }
    }
  }

  function closeAllRelatedColorPanels() {
    document.querySelectorAll(".product-main__related-color-panel.is-open").forEach(function (p) {
      p.classList.remove("is-open");
      restoreRelatedColorPanelFromBody(p);
      p.hidden = true;
      clearRelatedColorPanelLayout(p);
      var f = p.closest("[data-related-color-field]");
      var t = f && f.querySelector("[data-related-color-trigger]");
      if (t) t.setAttribute("aria-expanded", "false");
    });
  }

  var relatedColorRepositionBound = false;

  function ensureRelatedColorRepositionListeners() {
    if (relatedColorRepositionBound) return;
    relatedColorRepositionBound = true;
    function repositionOpenPanels() {
      document
        .querySelectorAll(".product-main__related-color-panel.is-open")
        .forEach(function (panel) {
          var field = panel.closest("[data-related-color-field]");
          var trigger = field && field.querySelector("[data-related-color-trigger]");
          if (trigger) positionRelatedColorPanel(trigger, panel);
        });
    }
    window.addEventListener("scroll", repositionOpenPanels, true);
    window.addEventListener("resize", repositionOpenPanels);
  }

  function ensureRelatedColorGlobalListeners() {
    if (relatedColorUiDocBound) return;
    relatedColorUiDocBound = true;
    ensureRelatedColorRepositionListeners();
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-related-color-field]")) return;
      closeAllRelatedColorPanels();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAllRelatedColorPanels();
    });
  }

  function syncRelatedColorTrigger(field) {
    var swatchEl = field.querySelector("[data-related-trigger-swatch]");
    var select = field.querySelector("select[name^='related_option']");
    var trigger = field.querySelector("[data-related-color-trigger]");
    if (!select || !swatchEl || !trigger) return;
    var val = select.value || "";
    var optLabel = field.getAttribute("data-related-color-option-name") || "Color";
    trigger.setAttribute("aria-label", optLabel + ": " + val);
    var foundSw = null;
    field.querySelectorAll("[data-related-swatch]").forEach(function (optBtn) {
      if (normOpt(optBtn.getAttribute("data-option-value")) === normOpt(val)) {
        foundSw = optBtn.querySelector(".product-main__related-swatch--row");
      }
    });
    if (foundSw) {
      swatchEl.style.backgroundImage = foundSw.style.backgroundImage;
      swatchEl.style.backgroundColor = foundSw.style.backgroundColor || "";
      swatchEl.style.backgroundSize = foundSw.style.backgroundSize || "cover";
      swatchEl.style.backgroundPosition = foundSw.style.backgroundPosition || "center";
    } else {
      swatchEl.style.backgroundImage = "";
      swatchEl.style.backgroundColor = "";
      swatchEl.style.backgroundSize = "";
      swatchEl.style.backgroundPosition = "";
    }
  }

  function bindRelatedColorDropdowns(slide) {
    ensureRelatedColorGlobalListeners();
    slide.querySelectorAll("[data-related-color-field]").forEach(function (field) {
      var trigger = field.querySelector("[data-related-color-trigger]");
      var panel = field.querySelector("[data-related-color-panel]");
      if (!trigger || !panel) return;
      if (trigger.dataset.relatedColorBound === "1") return;
      trigger.dataset.relatedColorBound = "1";
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = panel.classList.contains("is-open");
        closeAllRelatedColorPanels();
        if (!wasOpen) {
          panel.classList.add("is-open");
          panel.hidden = false;
          trigger.setAttribute("aria-expanded", "true");
          portalRelatedColorPanelToBody(panel);
          requestAnimationFrame(function () {
            positionRelatedColorPanel(trigger, panel);
          });
        }
      });
    });
  }

  function initRelated(root) {
    var track = root.querySelector("[data-related-track]");
    var prev = root.querySelector("[data-related-prev]");
    var next = root.querySelector("[data-related-next]");
    var bullets = root.querySelector("[data-related-bullets]");
    if (!track) return;

    var slides = track.querySelectorAll("[data-related-slide]");
    var n = slides.length;
    var idx = 0;

    function updateRelatedArrows() {
      if (n <= 1) {
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= n - 1;
    }

    function go(i) {
      idx = Math.max(0, Math.min(n - 1, i));
      closeAllRelatedColorPanels();
      track.style.transform = "translateX(-" + idx * 100 + "%)";
      if (bullets) {
        bullets.querySelectorAll("[data-related-bullet]").forEach(function (b, bi) {
          b.classList.toggle("is-active", bi === idx);
        });
      }
      updateRelatedArrows();
    }

    if (prev) {
      prev.addEventListener("click", function () {
        if (prev.disabled) return;
        go(idx - 1);
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        if (next.disabled) return;
        go(idx + 1);
      });
    }
    if (bullets) {
      bullets.querySelectorAll("[data-related-bullet]").forEach(function (b, bi) {
        b.addEventListener("click", function () {
          go(bi);
        });
      });
    }
    go(0);

    slides.forEach(function (slide) {
      var jsonEl = slide.querySelector(".product-main__related-json");
      if (!jsonEl) return;
      var pdata;
      try {
        pdata = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
      var variants = pdata.variants || [];

      function getSel() {
        var o1 = slide.querySelector('[name="related_option1"]');
        var o2 = slide.querySelector('[name="related_option2"]');
        var o3 = slide.querySelector('[name="related_option3"]');
        function vof(el) {
          return el ? el.value : null;
        }
        return [vof(o1), vof(o2), vof(o3)];
      }

      function syncRelatedSwatchAvailability() {
        var o = getSel();
        slide.querySelectorAll("[data-related-swatch]").forEach(function (btn) {
          var pos = parseInt(btn.getAttribute("data-option-position"), 10);
          if (isNaN(pos) || pos < 1 || pos > 3) return;
          var val = btn.getAttribute("data-option-value");
          var tryO = [o[0], o[1], o[2]];
          tryO[pos - 1] = val;
          var vv = findVariant(variants, tryO[0], tryO[1], tryO[2]);
          var exists = !!vv;
          var oos = !!(vv && !vv.available);
          btn.classList.toggle("is-unavailable", !exists || oos);
          btn.disabled = !exists;
        });
      }

      function upd() {
        var o = getSel();
        var v = findVariant(variants, o[0], o[1], o[2]);
        var img = slide.querySelector("[data-related-image]");
        var rpc = slide.querySelector("[data-related-price]");
        var rpcmp = slide.querySelector("[data-related-compare]");
        var add = slide.querySelector("[data-related-add]");
        var labAdd = add ? add.getAttribute("data-label-add") || "Add" : "Add";
        var labSold = add ? add.getAttribute("data-label-sold-out") || "Sold out" : "Sold out";
        var labUn = add ? add.getAttribute("data-label-unavailable") || "Unavailable" : "Unavailable";
        if (!v) {
          if (add) {
            add.disabled = true;
            add.textContent = labUn;
          }
          return;
        }
        if (add) {
          add.disabled = !v.available;
          add.dataset.variantId = String(v.id);
          add.textContent = v.available ? labAdd : labSold;
        }
        var iu = relatedSlideImageUrl(v, pdata);
        if (img && iu) {
          img.src = iu;
          img.alt = (pdata.title || "") + " — " + [v.option1, v.option2, v.option3].filter(Boolean).join(" / ");
        }
        if (rpc) rpc.textContent = formatMoney(v.price);
        if (rpcmp) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            rpcmp.textContent = formatMoney(v.compare_at_price);
            rpcmp.style.display = "";
          } else {
            rpcmp.style.display = "none";
          }
        }
      }

      function syncSwatchClasses() {
        slide.querySelectorAll("[data-related-swatch]").forEach(function (btn) {
          var pos = btn.getAttribute("data-option-position");
          var val = btn.getAttribute("data-option-value");
          var sel = slide.querySelector('select[name="related_option' + pos + '"]');
          var on = !!(sel && normOpt(sel.value) === normOpt(val));
          btn.classList.toggle("is-selected", on);
          if (btn.getAttribute("role") === "option") {
            btn.setAttribute("aria-selected", on ? "true" : "false");
          }
        });
      }

      function refreshRelatedSlideUi() {
        closeAllRelatedColorPanels();
        syncRelatedSwatchAvailability();
        syncSwatchClasses();
        upd();
        slide.querySelectorAll("[data-related-color-field]").forEach(syncRelatedColorTrigger);
      }

      slide.querySelectorAll("select[name^='related_option']").forEach(function (sel) {
        sel.addEventListener("change", function () {
          refreshRelatedSlideUi();
        });
      });
      slide.querySelectorAll("[data-related-swatch]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          if (btn.disabled) return;
          var pos = btn.getAttribute("data-option-position");
          var val = btn.getAttribute("data-option-value");
          var sEl = slide.querySelector('select[name="related_option' + pos + '"]');
          if (sEl) {
            sEl.value = val;
            refreshRelatedSlideUi();
          }
        });
      });

      bindRelatedColorDropdowns(slide);

      var add = slide.querySelector("[data-related-add]");
      if (add) {
        add.addEventListener("click", function () {
          var vid = add.dataset.variantId;
          if (!vid || add.disabled || add.classList.contains("is-loading")) return;
          var labelAdding = add.getAttribute("data-label-adding") || "Adding…";
          add.disabled = true;
          add.classList.add("is-loading");
          add.setAttribute("aria-busy", "true");
          add.setAttribute("aria-label", labelAdding);
          fetch(getCartAddUrl() + ".js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
          })
            .then(function (r) {
              return r.json().then(function (j) {
                if (!r.ok) throw j;
                if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
                  publish(PUB_SUB_EVENTS.cartUpdate, { action: "add" });
                }
              });
            })
            .catch(function () {})
            .finally(function () {
              add.classList.remove("is-loading");
              add.removeAttribute("aria-busy");
              add.removeAttribute("aria-label");
              refreshRelatedSlideUi();
            });
        });
      }

      refreshRelatedSlideUi();
    });
  }

  function initProductSection(sectionEl) {
    var root = sectionEl.querySelector("[data-product-section]");
    if (!root) return;

    var shell =
      sectionEl.querySelector(".product-main") ||
      (root.closest && root.closest(".product-main")) ||
      sectionEl;

    var sid = root.getAttribute("data-section-id");
    var data = readJson("product-main-json-" + sid, sectionEl);
    if (!data) return;

    initGallery(shell);
    shell
      .querySelectorAll(".product-main__colors-wrap[data-product-thumb-scroll]")
      .forEach(setupProductMainColorSwatchScroll);

    if (data.mode === "bundle") {
      initBundleMode(root, data);
    } else {
      initSingleProduct(root, data);
    }
    initCart(root, data);
    initRelated(root);

    root.querySelectorAll("[data-accordion-container]").forEach(function (el) {
      var accId = el.getAttribute("data-accordion-container");
      if (accId && typeof window.initAccordionSection === "function") {
        window.initAccordionSection(accId);
      }
    });
  }

  function boot() {
    document.querySelectorAll(".shopify-section").forEach(function (sec) {
      if (sec.querySelector("[data-product-section]")) initProductSection(sec);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    setTimeout(boot, 0);
  }

  window.initProductMainQuickAdd = function (container) {
    if (!container || !container.querySelector) return;
    if (!container.querySelector("[data-product-section]")) return;
    initProductSection(container);
  };

  document.addEventListener("shopify:section:load", function (ev) {
    var t = ev.target;
    if (t && t.querySelector && t.querySelector("[data-product-section]")) {
      initProductSection(t);
    }
  });
})();
